jQuery($ => {

  if($('.o-404-content')[0]){

    $(window).on('load', function() {
      const $scroll = $('.o-404-content__scroll');

      setTimeout(() => {
        $scroll.addClass('o-404-content__scroll--open');
      }, 500);
    });
  }

});